import {MARKETPLACE_DEMO_PATH} from "../../routes";

export default function openMarketplaceDemo() {
    window.open(MARKETPLACE_DEMO_PATH, '_blank', 'noopener,noreferrer');
}
